import React from "react";
import MainLayout from "../layout/MainLayout";
import { motion } from "framer-motion";
import { Car, Navigation, Clock } from "lucide-react";
import Drone3Img from '../assets/drone3.jpg'


export const OurServices = () => {
  return (
    <MainLayout>
      {/* Hero/Header Section */}
      <section
        className="relative h-[50vh] rounded-3xl mx-4 sm:mx-10 my-8 overflow-hidden shadow-xl bg-cover bg-center bg-no-repeat flex items-center justify-center text-white"
        style={{ backgroundImage: `url(${Drone3Img})` }}
      >
        <div className="absolute inset-0 bg-black/60 z-0" />
        <div className="relative z-10 text-center max-w-2xl px-6">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="text-4xl sm:text-5xl font-bold mb-4 just-me-again-down-here-regular"
          >
            Practical Car Hire. <br className="hidden sm:block" />
            Professional Delivery.
          </motion.h1>
        </div>
      </section>

      {/* Services Content */}
      <section className="max-w-5xl mx-auto px-6 mb-20">
        {/* Service 1: Car Hire */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white/30 dark:bg-white/10 backdrop-blur-md p-8 rounded-2xl shadow-lg border border-white/20 dark:border-white/10 mb-12"
        >
          <div className="flex items-center gap-4 mb-6">
            <Car className="w-8 h-8 text-teal-500" />
            <h2 className="text-4xl font-bold just-me-again-down-here-regular">Car Hire</h2>
          </div>
          <p className="text-gray-700 dark:text-gray-300 mb-4 text-lg">
            Whether it’s a short-term need or multiple days of movement, our
            fleet is ready.
          </p>
          <ul className="list-disc list-inside text-gray-700 dark:text-gray-400 space-y-2">
            <li>Daily or weekly bookings</li>
            <li>With or without a driver</li>
            <li>Clean, maintained vehicles</li>
            <li>Transparent pricing</li>
          </ul>
        </motion.div>

        {/* Service 2: Drop-off & Pickup */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white/30 dark:bg-white/10 backdrop-blur-md p-8 rounded-2xl shadow-lg border border-white/20 dark:border-white/10"
        >
          <div className="flex items-center gap-4 mb-6">
            <Navigation className="w-8 h-8 text-teal-500" />
            <h2 className="text-4xl font-bold just-me-again-down-here-regular">Drop-Off & Pick-Up</h2>
          </div>
          <p className="text-gray-700 dark:text-gray-300 mb-4 text-lg">
            For those who want convenience, we offer scheduled pickups and
            drop-offs — ideal for airport transfers, meetings, and errands.
          </p>
          <ul className="list-disc list-inside text-gray-700 dark:text-gray-400 space-y-2">
            <li>Timely and professional</li>
            <li>Custom location coordination</li>
            <li>Available across Kampala and nearby areas</li>
          </ul>
          <div className="mt-4 flex items-start gap-2 text-sm text-gray-600 dark:text-gray-400">
            <Clock className="w-4 h-4 mt-1 text-teal-500" />
            <p>
              <em>
                We also offer optional vehicle delivery within a reasonable time
                frame, subject to prevailing conditions such as traffic or
                accessibility.
              </em>
            </p>
          </div>
        </motion.div>
      </section>
    </MainLayout>
  );
};
